import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const PreviousEmploymentStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  flex: 1;

  .listSection {
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    flex: 1;
  }

  .listSectionItemBox {
    flex: 1;
    gap: 8px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
  }

  .emptyListSectionItem {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    // align-items: center;
    gap: 32px;
    height: 100%;
  }

  .emptyListSectionItemImgBox {
    border-radius: 50px;
    background: #e2f4ff;
    padding: 0px 0px 6px 18px;
    width: 100px;
    height: 100px;
    overflow: hidden;
  }

  .linkBox {
    border-radius: 16px;
    background: var(--GrayScale-100);
    padding: 0px 24px;
    width: 100%;
  }

  .listSectionItem {
    border-radius: 16px;
    border: 1px solid var(--GrayScale-400);
    background: var(--GrayScale-0);
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  /* 추가 버튼 섹션 */
  .addButtonSection {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .addButtonContainer {
    display: flex;
    gap: 16px;
  }

  .addButton {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;
    background: #f5f5f5;
    cursor: pointer;
  }

  .addButtonText {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .addButtonImg {
    height: 70px;
    object-fit: contain;
    align-self: flex-end;
  }

  /* 빈 리스트 메시지 */
  .emptyListMessage {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    border-radius: 16px;
    border: 1px dashed var(--GrayScale-400);
    text-align: center;
    white-space: pre-line;
  }
`;

/* 콘텐츠 래퍼 (개인정보 동의 등) */
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: var(--GrayScale-50);
  border-radius: 8px;
`;

/* 불릿 리스트 박스 (에러 화면 등) */
export const BulletBox = styled.div`
  border-radius: 8px;
  padding: 16px 8px;
  background: var(--GrayScale-100);
`;
